module.exports = __webpack_public_path__ + "assets/asian-195b79.svg";